import React, { useState } from 'react'

import PropTypes from 'prop-types';

import { Form, FormControl } from 'react-bootstrap'

/**
 * اینپوت شماره موبایل است<br>
 * این کامپوننت عتبار سنجی شماره موبایل رو انجام می دهد<br>
 */
export default function Mobile({ label, name, defaultValue, handelValue, Placeholder, autoComplete }) {

    const [error, setError] = useState("")

    const [colorerror, setColorerror] = useState('')

    const pattern = new RegExp(/^(0|0098|\+98)9\d{9}$/);

    const hedelonCheng = (event) => {

        if (event.target.value) {
            const vlaue = event.target.value

            if (pattern.test(vlaue)) {

                if (vlaue.length < 10) {

                }
                else {
                    setError('شماره موبایل قابل ثبت است')
                    setColorerror('green')
                    handelValue(name, vlaue)
                }
            }
            else {

                if (new RegExp(/^[0-9]+$/).test(vlaue)) {
                    setError('شماره موبایل خود را کامل وارد کنید')
                    setColorerror('red')
                }
                else {
                    setError('شماره موبایل فقط به عدد و انگلیسی قابل ثبت است')
                    setColorerror('red')

                }

            }


        }
        else {
            setError('')
            setColorerror('')
            handelValue(name, '')

        }
    }

    return (
        <Form.Group>
            {
                label ? <Form.Label>{label}</Form.Label>
                    : null
            }
            <FormControl type="text" placeholder={Placeholder ? Placeholder : ""} name={name ? name : ""} autoComplete={autoComplete ? "off" : null} defaultValue={defaultValue ? defaultValue : ""} dir="ltr" required onChange={hedelonCheng} maxLength="11" />
            {error ? <Form.Text className='mr-2' style={{ color: colorerror }} >{error}</Form.Text> : null}
        </Form.Group>
    )
}

Mobile.propTypes = {
    /** تابع ارسال داده به کامپوننت بالا سری است */
    handelValue: PropTypes.func
}